const MESSAGES = {
  ADDRESS_INVALID: "Please select a valid street address.",
  ADDRESS_LOCATION_INVALID: "Please select a valid address from the list.",
  ADDRESS_REQUIRED: "Please enter your address.",
  ADDRESS1_REQUIRED: "Please enter an address.",
  ADDRESS2_REQUIRED: "Please enter a suburb.",
  ADDRESS3_REQUIRED: "Please enter a postcode.",
  BODYSTYLE_REQUIRED: "Please select a body style.",
  BUSINESS_INVALID: "Please enter a valid business name.",
  BUSINESS_REQUIRED: "Please enter a business name.",
  DATE_REQUIRED: "Please select a date",
  DEALERS_NO_POSTCODE: "Please enter your postcode, suburb or dealer name.",
  DEALERS_REQUIRED: "Please select a dealer.",
  EMAIL_INVALID: "Please enter a valid email address.",
  EMAIL_MAXLENGTH: "Email is too long.",
  EMAIL_REQUIRED: "Please enter an email address.",
  FINANCE_REQUIRED: "Please select one of the options.",
  FIRSTNAME_MAXLENGTH: "First name must be shorter than 30 characters",
  FIRSTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_REQUIRED: "Please enter a first name.",
  FIRSTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  FIRSTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_MAXLENGTH: "Last name must be shorter than 50 characters",
  LASTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_REQUIRED: "Please enter a last name.",
  LASTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  LASTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LOCATION_INVALID: "Please select a valid postcode or suburb from the list.",
  LOCATION_REQUIRED: "Please enter your postcode or tell us which suburb you live in.",
  MOBILE_NUMBER_INVALID: "Please enter a valid mobile number",
  MOBILE_NUMBER_REQUIRED: "Please enter your mobile number.",
  MODEL_FREETEXT_REQUIRED: "Please enter a model.",
  MODEL_REQUIRED: "Please select a model from the drop-down list.",
  MODEL_REQUIRED: "Please select a model.",
  MULTIPLERESULTS: "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer.",
  NOTFOUND: "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
  NOTSUPPORTED: "Unfortunately the VIN/Rego number you entered is not supported. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
  ODOMETER_INVALID: "Please enter odometer value as a whole number.",
  ODOMETER_REQUIRED: "Please enter odometer value.",
  OPTIN_REQUIRED: "This is a mandatory field",
  PASSWORD_CASE: "Password must contain atleast one uppercase and one lowercase letter.",
  PASSWORD_MAXLENGTH: "Password is too long.",
  PASSWORD_MINLENGTH: "Password is too short.",
  PASSWORD_NUMBER_SYMBOL: "Password must contain atleast one number or symbol.",
  PASSWORD_REQUIRED: "Please enter a password.",
  PHONE_EXTENSION_INVALID: "The extension number you have entered is not valid. Please ensure it does not exceed 6 digits.",
  PHONE_NUMBER_AREACODE_INVALID: "Please enter a valid landline or mobile number using the correct area code.",
  PHONE_NUMBER_INVALID: "Please remove spaces or characters and ensure number at least 9 digits.",
  PHONE_NUMBER_REQUIRED: "Please enter your phone number.",
  POSTCODE_INVALID: "Please enter a valid postcode.",
  PRIVACY_POLICY_REQUIRED: "This is a mandatory field",
  PROFANITY_FILTER: "Your input has triggered the profanity filter, please try again",
  RECAPTCHA_REQUIRED: "This is a mandatory field",
  REGISTRATION_INVALID: "Please enter valid registration number.",
  REGO_OR_VIN_REQUIRED: "Please enter a valid registration or VIN.",
  SELECT_REQUIRED: "Please select one from the drop-down list.",
  SERVICE_MAX_TRIES: "Sorry, you've exceeded the number of tries for this service. Please try again later.",
  STATE_REQUIRED: "Please select your state.",
  TIME_INVALID: "Please enter time in the format HH/MM.",
  TIME_REQUIRED: "Please select a time",
  TITLE_REQUIRED: "Please select a title from the drop-down list.",
  TOPIC_REQUIRED: "Please select an enquiry topic from the drop-down list.",
  UNEXPECTED_ERROR: "Sorry, we've encountered an unexpected error. Please try again later.",
  VIN_INVALID: "Please enter a valid VIN number."
}

export default MESSAGES



// WEBPACK FOOTER //
// ./src/AtomicConstants/MESSAGES.js